import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import  UserList from "../../components/Web/WebUserListLayer";

const webuserList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Get In Touch"  />

        <UserList />
      </MasterLayout>
    </>
  );
};

export default webuserList;
